module.exports = __webpack_public_path__ + "static/media/16.a6097346.ogg";